import { hasOwnProperty } from "common/reducers/UtilsTypes";

/**
 * Converts an object to FormData. It will recursively convert nested objects and arrays.
 **/
export const objectToFormData = (obj: object, formData = new FormData(), parentKey = ""): FormData => {
  for (const key in obj) {
    if (hasOwnProperty(obj, key)) {
      const value = obj[key];
      const fullKey = parentKey ? `${parentKey}[${key}]` : key;

      if (Array.isArray(value)) {
        value.forEach((item) => {
          const arrayKey = `${fullKey}[]`;
          if (typeof item === "object" && item !== null) {
            objectToFormData(item, formData, arrayKey);
          } else {
            formData.append(arrayKey, item);
          }
        });
      } else if (typeof value === "object" && value !== null && !(value instanceof File)) {
        objectToFormData(value, formData, fullKey);
      } else if (typeof value === "string" || value instanceof Blob) {
        formData.append(fullKey, value);
      } else if (typeof value === "number" || typeof value === "boolean") {
        formData.append(fullKey, value.toString());
      } else {
        console.warn(`Unable to convert object to form data: unhandled type of value (${typeof value})`);
      }
    }
  }
  return formData;
};
